export interface EmployeeReportDocument {
  id: number;
  createdAt: string;
  employeesSubmasterId: number;
  pdfdocumentregistered: string | null;
}

const isNewerDocument = <T extends EmployeeReportDocument>(
  candidate: T,
  current: T
) => {
  const candidateTime = new Date(candidate.createdAt).getTime();
  const currentTime = new Date(current.createdAt).getTime();

  if (
    Number.isFinite(candidateTime) &&
    Number.isFinite(currentTime) &&
    candidateTime !== currentTime
  ) {
    return candidateTime > currentTime;
  }

  return candidate.id > current.id;
};

export const summarizeDocumentsByEmployee = <T extends EmployeeReportDocument>(
  documents: T[]
): T[] => {
  const documentsByEmployee = new Map<
    number,
    { latest: T; latestWithPdf: T | null }
  >();

  documents.forEach((document) => {
    const current = documentsByEmployee.get(document.employeesSubmasterId);

    if (!current) {
      documentsByEmployee.set(document.employeesSubmasterId, {
        latest: document,
        latestWithPdf: document.pdfdocumentregistered ? document : null,
      });
      return;
    }

    if (isNewerDocument(document, current.latest)) {
      current.latest = document;
    }

    if (
      document.pdfdocumentregistered &&
      (!current.latestWithPdf ||
        isNewerDocument(document, current.latestWithPdf))
    ) {
      current.latestWithPdf = document;
    }
  });

  return Array.from(documentsByEmployee.values()).map(
    ({ latest, latestWithPdf }) => ({
      ...latest,
      pdfdocumentregistered: latestWithPdf?.pdfdocumentregistered || null,
    })
  );
};
